import { isEmpty } from "lodash-es";
import { Button, PlusCircleIcon, useMessage } from "melco-ui";
import { useTranslation } from "react-i18next";
import {
  IdentityMelcoModelsProductVersionListItem,
  useConfirm,
} from "melco-shared-logic";
import { useUserProductStartTrial } from "../../hooks/users/useUserProductStartTrial";
import { useUserProductGetVersions } from "../../hooks/users/useUserProductGetVersions";

type UserProductStartTrialActionButtonProps = {
  productCodeToStartTrial: string;
  callBackFn?: () => void;
  buttonName: string;
};

export const UserProductStartTrialActionButton: React.FC<
  UserProductStartTrialActionButtonProps
> = ({ callBackFn, productCodeToStartTrial, buttonName }) => {
  const { t } = useTranslation();
  const message = useMessage();
  const startTrialProduct = useUserProductStartTrial();
  const productVersions = useUserProductGetVersions();
  const confirmStartTrialProduct = useConfirm(
    async () => {
      // Get Version and version logic
      // call start trial API pass version number
      const productVersionsResponse = await productVersions(
        productCodeToStartTrial
      );

      const versionsList: IdentityMelcoModelsProductVersionListItem[] =
        productVersionsResponse?.list ?? [];
      // console.log(productVersionsResponse)
      if (!(versionsList.length == 1)) {
        // show message
        //const errormessage = t("users.products.actions.start_trial.not_valid_version")
        message.error(
          t("users.products.actions.start_trial.not_valid_version")
        );
        return;
      }
      // console.log(productVersionsResponse)
      //let productVersionObj: IdentityMelcoModelsProductVersionListItem = productVersionsResponse?.list
      const successfullyStartTrialedProduct = await startTrialProduct(
        productCodeToStartTrial,
        versionsList?.[0]?.version_number ?? ""
      );

      if (callBackFn && !isEmpty(successfullyStartTrialedProduct)) {
        callBackFn();
      }
    },
    {
      translationPrefix: "users.products.actions.start_trial",
    }
  );

  // if (isEmpty(selectedRowKeys)) {
  //     return null;
  // }

  return (
    <Button
      key="startTrialProduct"
      type="primary"
      icon={<PlusCircleIcon />}
      //disabled={isEmpty(selectedRowKeys)}
      onClick={async () => {
        const response = await confirmStartTrialProduct();
      }}
      style={{ minWidth: "115px" }}
    >
      {t("users.products.actions.start_trial.button")}
    </Button>
  );
};
